/**
 * DevBypassBanner — top-of-screen warning that auth bypass is active.
 *
 * Renders only when GET /api/auth/dev-bypass-status reports active=true.
 * That endpoint reads `DEV_AUTH_BYPASS` from backend/.env — flip it to
 * 0 to make this banner disappear AND restore normal auth.
 *
 * Why visible: easy to forget that login was disabled. Without this
 * banner the system would feel "open" and could ship to production
 * with a security hole.
 */
import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "../lib/api";

export default function DevBypassBanner() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get("/auth/dev-bypass-status")
      .then((r) => { if (!cancelled) setActive(!!r.data?.active); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!active) return null;
  return (
    <div
      dir="rtl"
      data-testid="dev-bypass-banner"
      className="w-full bg-amber-500 text-amber-950 text-[12px] font-bold px-4 py-1.5 flex items-center justify-center gap-2 shadow-md z-[10010] sticky top-0"
    >
      <AlertTriangle className="w-3.5 h-3.5" />
      <span>DEV AUTH BYPASS פעיל — הכניסה מבוטלת זמנית. כבי ב-backend/.env (DEV_AUTH_BYPASS=0) לפני production</span>
    </div>
  );
}
